import { Theme, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import BackgroundPic from '../../assets/background_isotipo_dark.svg';

const accountStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    textAlign: 'center',
    backgroundColor: theme.palette.primary.main,
    backgroundImage: `url(${BackgroundPic})`,
    backgroundRepeat: 'repeat',
    backgroundSize: '10%',
  },
  paper: {
    margin: theme.spacing(3, 15),
    padding: '30px',
    textAlign: 'center',
    minHeight: '58vh',
    maxHeight: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.white.main,
    [theme.breakpoints.down('md')]: {
      padding: '5% 25px',
      margin: theme.spacing(3, 1),
    },
  },
  baseBackground: {
    minHeight: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      backgroundSize: 0,
      textAlign: 'center',
    },
  },
  contentContainer: {
    marginTop: '1%',
    width: '100%',
  },
  backButton: {
    marginTop: '5px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    transition: '0.5s',
    '&:hover': {
      fontWeight: 'bold',
      color: theme.palette.secondary.main,
    },
  },
  pacGrid: {
    paddingTop: 10,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      paddingBottom: 100,
    },
  },
}));

export const sx = () => {
  const theme = useTheme();
  return ({
    cardContainer: {
      textAlign: 'center',
      borderRadius: 5,
      maxWidth: 500,
      maxHeight: 100,
      display: 'flex',
      justifyContent: 'center',
      paddingBlock: 16,
      paddingInline: 5,
      [theme.breakpoints.down('md')]: {
        maxWidth: 'none',
      },
    },
    card: {
      borderRadius: '15px',
      paddingInline: { xs: 1, md: 0 },
      paddingTop: 0,
      paddingBottom: 0,
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      backgroundColor: theme.palette.white.main,
      width: '100%',
    },
  });
};

export default accountStyles;
